import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    error: null,
    data: null,
    success: false,
};

export const changePasswordReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CHANGE_PASSWORD_START:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };
        case types.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                success: true,
                error: null,
            };
        case types.CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false,
            };
        default:
            return state;
    }
};
